export default __webpack_public_path__ + "static/singleCardImg-0342f23ee9e2eb311602bc4a132a41ee.webp";